import { useExerciseIdsSelect } from '@entities/exercise-video/model.ts';
import { useState } from 'react';
import { Tooltip } from '@mui/material';
import { Search } from '@features/common';
import { AddThin, ArrowShortLeft, FilterIcon } from '@shared/assets';
import { useMobile, useWindowWidth } from '@shared/hooks';
import { usePagesRedirect } from '@shared/hooks/use-pages-redirect.ts';
import { IconButton, PageHead, PageTitle, TextButton } from '@shared/ui';
import { FilterMobileActions } from '@shared/ui/filter-mobile-actions/index.ts';
import { SSearchIcon } from '@shared/ui/inputs/searchInput/styles';

interface Props {
  mobileWithFilterOn: boolean;
  addVideo: () => void;
  onSearch: (value: string) => void;
  search: string;
  showFilterBar: boolean;
  setShowFilterBar: React.Dispatch<React.SetStateAction<boolean>>;
  titles: string[];
  handleResetFilter: () => void;
  filterBtnIsActive: boolean;
  isFilterActive: boolean;
  setMobileWithFilterOn: (value: boolean) => void;
}

export const ExerciseListHead = ({
  addVideo,
  onSearch,
  search,
  setShowFilterBar,
  titles,
  handleResetFilter,
  filterBtnIsActive,
  mobileWithFilterOn,
  setMobileWithFilterOn,
  isFilterActive,
  showFilterBar,
}: Props): JSX.Element => {
  const { isSelecting, setIsSelectingFalse } = useExerciseIdsSelect();
  const { doRedirectOnPrevPage } = usePagesRedirect('programsList');
  const { doRedirectOnPrevPage: redirectToEditor } = usePagesRedirect('librarySelection');
  const [isSearchMobile, setIsSearchMobile] = useState(false);
  const windowWidth = useWindowWidth();
  const { isMobile } = useMobile();

  const goBack = (): void => {
    if (isSelecting) {
      redirectToEditor();
      setIsSelectingFalse();
    } else {
      doRedirectOnPrevPage('/programs/library?tab=my');
    }
  };

  const handleShowFilterBar = (): void => {
    isMobile && setMobileWithFilterOn(true);
    showFilterBar && handleResetFilter();
    setShowFilterBar((prev) => !prev);
  };

  return (
    <>
      {!isSearchMobile && (
        <>
          <PageHead
            Center={mobileWithFilterOn ? 'Фильтр' : `Библиотека ${!isMobile ? 'видео' : ''}`}
            Left={
              <IconButton variant="dark" onClick={goBack}>
                <ArrowShortLeft />
              </IconButton>
            }
            Right={
              <>
                {mobileWithFilterOn ? (
                  <FilterMobileActions
                    isFilterActive={isFilterActive}
                    onReset={handleResetFilter}
                    onConfirm={() => {
                      setMobileWithFilterOn(false);
                      setShowFilterBar((prev) => !prev);
                    }}
                  />
                ) : (
                  <>
                    {windowWidth > 570 ? (
                      <Search search={search} onSearch={onSearch} titles={titles} />
                    ) : (
                      <IconButton
                        variant="mobile"
                        onClick={() => setIsSearchMobile(!isSearchMobile)}
                      >
                        <SSearchIcon />
                      </IconButton>
                    )}
                    <Tooltip title={'Фильтр'}>
                      <IconButton
                        variant={`${filterBtnIsActive ? 'activeDark' : 'dark'}`}
                        onClick={handleShowFilterBar}
                      >
                        <FilterIcon />
                      </IconButton>
                    </Tooltip>

                    <Tooltip title={'Новое видео'}>
                      <IconButton variant="dark" onClick={addVideo}>
                        <AddThin />
                      </IconButton>
                    </Tooltip>
                    {isSelecting && (
                      <TextButton type="button" onClick={goBack}>
                        Готово
                      </TextButton>
                    )}
                  </>
                )}
              </>
            }
          />
        </>
      )}

      {isSearchMobile && (
        <>
          <PageTitle title="Поиск" />
          <PageHead
            Left={
              <IconButton
                variant="dark"
                onClick={() => {
                  setIsSearchMobile(!isSearchMobile);
                  onSearch('');
                }}
              >
                <ArrowShortLeft />
              </IconButton>
            }
            Right={<Search mobile search={search} onSearch={onSearch} titles={titles} />}
          />
        </>
      )}
    </>
  );
};
